export const formataResultado = (values) => {
  const resultado = {
    questao1: values.questao1,
    questao2: values.questao2,
    questao3: values.questao3,
    questao4: values.questao4,
    questao5: values.questao5,
    questao6: values.questao6,
    questao7: values.questao7,
  };
  return JSON.stringify(resultado).replaceAll(`"`, `'`);
};
